module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAJNJREFUOE9jZKAAMFKgl2GoaN7e4MDg2XAA5lXinb2zuZ6R4X/of/c6Heyatzc2MHjWN2AEIkwjM0sYg0vVNayamXY2tv1nYFL5714bBjdge2MDIxNjyH80jSB5DGcz7Wic8p+RSQxsAB6NWDWDBJl2Ni/4z/DfBMTGZiPhANvRvJ+BhTkb2Y/oYUF8aGNJikNUMwBjKDAQ3qSB/gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yes.png
// module id = aElj
// module chunks = 5